import React from "react";
import DietPlanOverview from "@features/diet/DietPlanOverview";

const DashboardDietPlan = ({
  tab,
  setTab,
  selectedMeal,
  selectedMeals,
}) => {
  const selectedDay = selectedMeal?.title;

  return (
    <DietPlanOverview
      selectedMeal={selectedMeal}
      selectedDay={selectedDay}
      selectedMeals={selectedMeals}
      variant="dashboard"
      showHeader={false}
      showClock={false}
      navigateTo="/dashboard/recipe-detail"
      stateKey="dashboard"
      tab={tab}
      setTab={setTab}
    />
  );
};

export default DashboardDietPlan;